(() => {
  if (customElements.get('watashi-product-slider')) return;

  class WatashiProductSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      if (!this.track) return;

      this.pending = false;
      this.dragging = false;
      this.moved = false;
      this.startX = 0;
      this.startScroll = 0;

      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());

      if (window.matchMedia('(pointer: fine)').matches) {
        this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
        this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event));
        this.track.addEventListener(
          'click',
          (event) => {
            if (this.moved) {
              event.preventDefault();
              event.stopPropagation();
            }
            this.moved = false;
          },
          true
        );
      }

      this.updateButtons();
    }

    slideSize() {
      const slide = this.track.querySelector('.watashi-product-slider__slide');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    go(direction) {
      const size = this.slideSize();
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (!size || maxScroll <= 4) return;

      let nextLeft = this.track.scrollLeft + direction * size;
      if (direction > 0 && this.track.scrollLeft >= maxScroll - 4) {
        nextLeft = 0;
      } else if (direction < 0 && this.track.scrollLeft <= 4) {
        nextLeft = maxScroll;
      }

      this.track.scrollTo({
        left: nextLeft,
        behavior: this.reducedMotion() ? 'auto' : 'smooth',
      });
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      this.pending = true;
      this.dragging = false;
      this.moved = false;
      this.startX = event.clientX;
      this.startScroll = this.track.scrollLeft;
    }

    onPointerMove(event) {
      if (!this.pending && !this.dragging) return;
      const delta = event.clientX - this.startX;
      if (this.pending && Math.abs(delta) > 10) {
        this.pending = false;
        this.dragging = true;
        this.moved = true;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);
      }
      if (!this.dragging) return;
      this.track.scrollLeft = this.startScroll - delta;
    }

    onPointerUp() {
      this.pending = false;
      if (!this.dragging) return;
      this.dragging = false;
      this.track.classList.remove('is-dragging');
      this.snap();
    }

    snap() {
      const size = this.slideSize();
      if (!size) return;
      const index = Math.round(this.track.scrollLeft / size);
      this.track.scrollTo({
        left: index * size,
        behavior: this.reducedMotion() ? 'auto' : 'smooth',
      });
    }

    updateButtons() {
      const canScroll = this.track.scrollWidth - this.track.clientWidth > 4;
      if (this.prev) this.prev.disabled = !canScroll;
      if (this.next) this.next.disabled = !canScroll;
    }
  }

  customElements.define('watashi-product-slider', WatashiProductSlider);
})();
